var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h3 text-center"},[_c('v-toolbar-title',{attrs:{"id":"title"}},[(_vm.icon)?_c('v-icon',{class:_vm.icon,attrs:{"id":"ic"}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "+_vm._s(_vm.main)+" ")],1),_c('small',[_vm._v(_vm._s(_vm.sub))]),_c('hr',{staticClass:"orange"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }